import { Link } from "@/components/common/Link";
const solutionLinks = [{
  label: "Process Analytical Technology",
  to: "/ProcessAnalyticalTechnologyPage"
}, {
  label: "Raw Material Identification",
  to: "/RawMaterialIdentificationPage"
}, {
  label: "Powder Testing",
  to: "/PowderTestingPage"
}, {
  label: "Safety and Security",
  to: "/SafetyAndSecurityPage"
}, {
  label: "HPLC Solvent Recovery",
  to: "/HplcSolventRecoveryResolvePage"
}, {
  label: "Tablet Testing",
  to: "/TabletTestingPage"
}];
const supportLinks = [{
  label: "Contact",
  to: "/ContactPage"
}, {
  label: "Discuss Your Application",
  to: "/DiscussYourApplicationPage"
}, {
  label: "Request a Quote",
  to: "/RequestAQuotePage"
}, {
  label: "Support Request",
  to: "/SupportRequestPage"
}];
const legalLinks: {
  label: string;
  to: string;
}[] = [];
export default function Footer() {
  return <footer id="contact" className="w-full relative overflow-hidden" style={{
    backgroundColor: "rgb(13, 44, 70)",
    color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)",
    fontFamily: "Inter, Arial, Helvetica, sans-serif"
  }}>
      <div className="page-container pt-8 md:pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-6 md:gap-8 pb-10">
          <div>
            <p className="text-[14px] leading-[22.75px] max-w-[320px]" style={{
            color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.7)"
          }}>
              Application-led analytical technology, qualification and lifecycle support for regulated laboratories and manufacturing teams across Ireland and the UK.
            </p>
          </div>

          <div>
            <h3 className="text-[14px] font-semibold leading-[20px] text-white mb-4" style={{
            color: "rgb(255, 255, 255)"
          }}>
              Solutions
            </h3>
            <ul className="space-y-[10px]">
              {solutionLinks.map(item => <li key={item.label}>
                  <Link to={item.to} className="text-[14px] leading-[20px] transition-colors duration-150 hover:text-white" style={{
                color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)"
              }}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="text-[14px] font-semibold leading-[20px] text-white mb-4" style={{
            color: "rgb(255, 255, 255)"
          }}>
              Support
            </h3>
            <ul className="space-y-[10px]">
              {supportLinks.map(item => <li key={item.label}>
                  <Link to={item.to} className="text-[14px] leading-[20px] transition-colors duration-150 hover:text-white" style={{
                color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)"
              }}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="text-[14px] font-semibold leading-[20px] text-white mb-4" style={{
            color: "rgb(255, 255, 255)"
          }}>
              Contact
            </h3>
            <div className="space-y-4">
              <div className="text-[14px] leading-[22.75px]" style={{
              color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.7)"
            }}>
                <p>Unit 21, Waterford Business Park</p>
                <p>Cork Road, Waterford, Ireland</p>
                <p>X91 P224</p>
              </div>

              <div>
                <p className="text-[12px] font-semibold leading-[16px] tracking-[0.3px] uppercase mb-2" style={{
                color: "oklab(0.999994 0.0000455678 0.0000200868 / 0.5)"
              }}>
                  IRELAND
                </p>
                <div className="space-y-1.5">
                  <div className="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-white/80">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <a href="tel:+35351392391" className="text-[14px] leading-[20px] transition-colors duration-150 hover:text-white" style={{
                    color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)"
                  }}>
                      +353 (0)51 392 391
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-white/80">
                      <rect width="20" height="16" x="2" y="4" rx="2" />
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                    </svg>
                    <a href="mailto:info@antech.ie" className="text-[14px] leading-[20px] transition-colors duration-150 hover:text-white" style={{
                    color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)"
                  }}>
                      info@antech.ie
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <p className="text-[12px] font-semibold leading-[16px] tracking-[0.3px] uppercase mb-2" style={{
                color: "oklab(0.999994 0.0000455678 0.0000200868 / 0.5)"
              }}>
                  UNITED KINGDOM
                </p>
                <div className="space-y-1.5">
                  <div className="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-white/80">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <a href="tel:+442034689813" className="text-[14px] leading-[20px] transition-colors duration-150 hover:text-white" style={{
                    color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)"
                  }}>
                      +44 (0)20 346 898 13
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-white/80">
                      <rect width="20" height="16" x="2" y="4" rx="2" />
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                    </svg>
                    <a href="mailto:info@antechsolutions.co.uk" className="text-[14px] leading-[20px] transition-colors duration-150 hover:text-white" style={{
                    color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)"
                  }}>
                      info@antechsolutions.co.uk
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] leading-[16px]" style={{
        borderTop: "1px solid rgba(255, 255, 255, 0.1)"
      }}>
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 lg:gap-4">
            <p style={{
            color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.6)"
          }}>
              © 2026 Antech Solutions Ltd. All rights reserved.
            </p>
            <span className="hidden lg:inline-block h-3.5 w-px bg-white/20" aria-hidden="true" />
            <p className="max-w-[580px]" style={{
            color: "oklab(0.999994 0.0000455678 0.0000200868 / 0.4)"
          }}>
              Antech Solutions Ltd. · Reg. no. IE 333028 · VAT IE6353028U · Authorised distributor for Bruker, VIAVI Solutions, Rigaku and Copley Scientific in Ireland and the UK.
            </p>
          </div>

          <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 shrink-0">
            {legalLinks.map(item => <Link key={item.label} to={item.to} className="transition-colors duration-150 hover:text-white" style={{
            color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.6)"
          }}>
                {item.label}
              </Link>)}
          </nav>
        </div>
      </div>
    </footer>;
}